import information from '@/views/mainContentScore/information'

import standardManage from '@/views/mainContentScore/information/standardManage'

import standardManageOrganization from '@/views/mainContentScore/information/standardManage/organization'

import legal from '@/views/mainContentScore/information/standardManage/organization/legal'
import system from '@/views/mainContentScore/information/standardManage/organization/system'
import system1 from '@/views/mainContentScore/information/standardManage/organization/system1'
import team from '@/views/mainContentScore/information/standardManage/organization/team'

import goods from '@/views/mainContentScore/information/standardManage/goods'

import goodsselect from '@/views/mainContentScore/information/standardManage/goods/goodsselect'
import goodslogin from '@/views/mainContentScore/information/standardManage/goods/goodslogin'
import goodsprotect from '@/views/mainContentScore/information/standardManage/goods/goodsprotect'
import goodsbg from '@/views/mainContentScore/information/standardManage/goods/goodsbg'

import open from '@/views/mainContentScore/information/standardManage/open'
import infomations from '@/views/mainContentScore/information/standardManage/open/infomations'
import visit from '@/views/mainContentScore/information/standardManage/open/visit'

import safety from '@/views/mainContentScore/information/standardManage/safety'
import realize from '@/views/mainContentScore/information/standardManage/safety/realize'
import goodssafety from '@/views/mainContentScore/information/standardManage/safety/goods'
import publics from '@/views/mainContentScore/information/standardManage/safety/public'
import info from '@/views/mainContentScore/information/standardManage/safety/info'


import service from '@/views/mainContentScore/information/service'
import science from '@/views/mainContentScore/information/service/science'
import output from '@/views/mainContentScore/information/service/science/output'
import service1 from '@/views/mainContentScore/information/service/science/service'


import list from '@/views/mainContentScore/information/service/list'
import base from '@/views/mainContentScore/information/service/list/base'
import shorttime from '@/views/mainContentScore/information/service/list/shorttime'

import teac from '@/views/mainContentScore/information/service/teac'
import explain from '@/views/mainContentScore/information/service/teac/explain'
import exercise from '@/views/mainContentScore/information/service/teac/exercise'
import appraisal from '@/views/mainContentScore/information/service/teac/appraisal'


import culture from '@/views/mainContentScore/information/service/culture'
import communication from '@/views/mainContentScore/information/service/culture/communication'
import communicate from '@/views/mainContentScore/information/service/culture/communicate'
import numbers from '@/views/mainContentScore/information/service/culture/number'
import management from '@/views/mainContentScore/information/service/culture/management'

import society from '@/views/mainContentScore/information/society'
import audience from '@/views/mainContentScore/information/society/audience'
import structure from '@/views/mainContentScore/information/society/audience/structure'
import Satisfaction from '@/views/mainContentScore/information/society/audience/Satisfaction'

import influence from '@/views/mainContentScore/information/society/influence'
import follow from '@/views/mainContentScore/information/society/influence/follow'
import reward from '@/views/mainContentScore/information/society/influence/reward'
import participate from '@/views/mainContentScore/information/society/influence/participate'

import special from '@/views/mainContentScore/information/special'
import cut from '@/views/mainContentScore/information/cut'
import synthesize from '@/views/mainContentScore/information/synthesize'
import enclosure from '@/views/mainContentScore/information/enclosure'
import download from '@/views/mainContentScore/information/download'

import basemenu from '@/views/mainContentScore/information/base'

import museumperson from '@/views/mainContentScore/user'
import addmuseumperson from '@/views/mainContentScore/user/listNew'

import specialist from '@/views/mainContentScore/specialist'

import addspecialist from '@/views/mainContentScore/specialist/listNew'

import country from '@/views/mainContentScore/country'
import addcountry from '@/views/mainContentScore/country/listNew'
import province from '@/views/mainContentScore/province'
import addprovince from '@/views/mainContentScore/province/listNew'
import pftj from '@/views/mainContentScore/pftj'

import fujian from "../views/mainContent/information/fujian";
import otherfile from '@/views/mainContent/information/otherfile'
import pfcx from '@/views/mainContentScore/pfcx'


export default {
  path: '/informationDeclarationScore',
  component: information,
  exact: true,
  children: [
    {
      path: '/informationDeclaration/museumbaseinfoScore',
      component: basemenu,
      exact: true,
    },
    {
      path: '/standardManageScore',
      component: standardManage,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/standardManage/organizationScore',
          component: standardManageOrganization,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/organization/legalScore',
              component: legal,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/systemScore',
              component: system,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/system1Score',
              component: system1,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/teamScore',
              component: team,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/goodsScore',
          component: goods,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/goods/goodsselectScore',
              component: goodsselect,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsloginScore',
              component: goodslogin,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsbgScore',
              component: goodsbg,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsprotectScore',
              component: goodsprotect,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/openScore',
          component: open,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/open/infomationsScore',
              component: infomations,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/open/visitScore',
              component: visit,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/safetyScore',
          component: safety,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/safety/realizeScore',
              component: realize,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/goodsScore',
              component: goodssafety,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/publicScore',
              component: publics,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/infoScore',
              component: info,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/serviceScore',
      component: service,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/service/scienceScore',
          component: science,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/science/outputScore',
              component: output,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/science/serviceScore',
              component: service1,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/listScore',
          component: list,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/list/baseScore',
              component: base,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/list/shorttimeScore',
              component: shorttime,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/teacScore',
          component: teac,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/teac/explainScore',
              component: explain,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/exerciseScore',
              component: exercise,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/appraisalScore',
              component: appraisal,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/cultureScore',
          component: culture,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/culture/communicationScore',
              component: communication,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/communicateScore',
              component: communicate,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/numberScore',
              component: numbers,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/managementScore',
              component: management,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/societyScore',
      component: society,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/society/audienceScore',
          component: audience,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/audience/structureScore',
              component: structure,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/audience/SatisfactionScore',
              component: Satisfaction,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/society/influenceScore',
          component: influence,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/influence/followScore',
              component: follow,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/rewardScore',
              component: reward,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/participateScore',
              component: participate,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/addition/specialScore',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureScore',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadScore',
      component: download,
      exact: true,
    },
    {
      path: '/informationDeclaration/museumperson',
      component: museumperson,
      exact: true,
    },
    {
      path: '/informationDeclaration/addmuseumperson',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/informationDeclaration/specialist',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningScore',
      component: cut,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/proposalScore',
      component: synthesize,
      exact: true,
    },
    {
      path: '/informationDeclaration/addspecialist',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/country',
      component: country,
      exact: true,
    },
    {
      path: '/informationDeclaration/addcountry',
      component: addcountry,
      exact: true,
    },
    {
      path: '/informationDeclaration/province',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovince',
      component: addprovince,
      exact: true,
    },
    {
      path: '/informationDeclaration/pftj',
      component: pftj,
      exact: true,
    },
    {
      path: '/scoreScore',
      component: pfcx,
      exact: true,
    },
  ]
}
